__turbopack_context__.v({
  "blue-elements": "lV-wRq_blue-elements",
  "navbar": "lV-wRq_navbar",
  "navbar-to-blue": "lV-wRq_navbar-to-blue",
  "scrolled": "lV-wRq_scrolled",
});
